module.exports = __webpack_public_path__ + "static/media/Abigail Bayer Headshot.31f21a95.jpeg";